import React from 'react';
import './styles.scss';
import Formats from 'utils/formats';

interface Props {
  nielsenDate: string;
  spinsDate: string;
}

const Updates: React.FC<Props> = ({ nielsenDate, spinsDate }) => (
  <div className="updates">
    {spinsDate ? <span>{`SPINS: updated through ${Formats.date(spinsDate)}`} </span> : null}
    {nielsenDate ? <span> {`Nielsen: updated through ${Formats.date(nielsenDate)}`} </span> : null}
  </div>
);

export default Updates;
